import { THERAPY_TYPE_CODE } from '@/constants/appointmentOptions';

export interface AppointmentColorClasses {
  softBg: string;
  accentText: string;
  accentBorder: string;
  accentBorderLeft: string;
  accentDot: string;
}

const OTHER_COLOR_CLASSES: AppointmentColorClasses = {
  softBg: 'bg-zooeventotherbg',
  accentText: 'text-zooeventotheraccent',
  accentBorder: 'border-zooeventotheraccent',
  accentBorderLeft: 'border-l-zooeventotheraccent',
  accentDot: 'bg-zooeventotheraccent',
};

const THERAPY_TYPE_COLOR_CLASSES: Record<string, AppointmentColorClasses> = {
  [THERAPY_TYPE_CODE.firstConsultation]: {
    softBg: 'bg-zooeventconsultbg',
    accentText: 'text-zooeventconsultaccent',
    accentBorder: 'border-zooeventconsultaccent',
    accentBorderLeft: 'border-l-zooeventconsultaccent',
    accentDot: 'bg-zooeventconsultaccent',
  },
  [THERAPY_TYPE_CODE.therapyContinuation]: {
    softBg: 'bg-zooeventcontinuebg',
    accentText: 'text-zooeventcontinueaccent',
    accentBorder: 'border-zooeventcontinueaccent',
    accentBorderLeft: 'border-l-zooeventcontinueaccent',
    accentDot: 'bg-zooeventcontinueaccent',
  },
  [THERAPY_TYPE_CODE.laserMls]: {
    softBg: 'bg-zooeventlaserbg',
    accentText: 'text-zooeventlaseraccent',
    accentBorder: 'border-zooeventlaseraccent',
    accentBorderLeft: 'border-l-zooeventlaseraccent',
    accentDot: 'bg-zooeventlaseraccent',
  },
  [THERAPY_TYPE_CODE.manualTherapy]: {
    softBg: 'bg-zooeventmanualbg',
    accentText: 'text-zooeventmanualaccent',
    accentBorder: 'border-zooeventmanualaccent',
    accentBorderLeft: 'border-l-zooeventmanualaccent',
    accentDot: 'bg-zooeventmanualaccent',
  },
  [THERAPY_TYPE_CODE.individualExercises]: {
    softBg: 'bg-zooeventexercisebg',
    accentText: 'text-zooeventexerciseaccent',
    accentBorder: 'border-zooeventexerciseaccent',
    accentBorderLeft: 'border-l-zooeventexerciseaccent',
    accentDot: 'bg-zooeventexerciseaccent',
  },
  [THERAPY_TYPE_CODE.followUp]: {
    softBg: 'bg-zooeventfollowupbg',
    accentText: 'text-zooeventfollowupaccent',
    accentBorder: 'border-zooeventfollowupaccent',
    accentBorderLeft: 'border-l-zooeventfollowupaccent',
    accentDot: 'bg-zooeventfollowupaccent',
  },
  [THERAPY_TYPE_CODE.other]: OTHER_COLOR_CLASSES,
};

export function resolveAppointmentColorClasses(therapyTypeCode: string): AppointmentColorClasses {
  const classes = THERAPY_TYPE_COLOR_CLASSES[therapyTypeCode];
  return classes === undefined ? OTHER_COLOR_CLASSES : classes;
}
